import React from 'react'
import { Box, Checkbox, FormControlLabel, FormGroup } from '@material-ui/core'
import PropTypes from 'prop-types'

const StyledCheckbox = ({
  input: { value, onChange },
  label,
  className,
}) => (
  <Box display="flex" alignItems="center">
    <FormGroup>
      <FormControlLabel control={<Checkbox 
        checked={value}
        onClick={() => onChange(+!value)}
        className={className} 
      />} label={label} />
    </FormGroup>
  </Box>
)

StyledCheckbox.defaultProps = {
  className: undefined,
}

StyledCheckbox.propTypes = {
  input: PropTypes.shape().isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default StyledCheckbox
